import AudioRecorder from './AudioRecorder'
export * from './AudioRecorder'
export default AudioRecorder
